import { dcFactory, DcBaseComponent } from '@deleteagency/dc';
import keyBy from 'lodash/keyBy';

const CLASS_ACTIVE = 'is-active';

export default class TabsComponent extends DcBaseComponent {
    static getNamespace() {
        return 'tabs';
    }

    static getRequiredRefs() {
        return ['triggers', 'content'];
    }

    onInit() {
        this.triggers = this.refs.triggers;
        this.content = this.refs.content;
        this.activeTrigger = this.triggers.find(el => el.classList.contains(CLASS_ACTIVE));
        this.activeContent = this.content.find(el => el.classList.contains(CLASS_ACTIVE));

        this.contentById = keyBy(this.content, el => el.getAttribute('data-id'));

        this.triggers.forEach((el) => {
            const id = el.getAttribute('data-target');
            this.addListener(el, 'click', () => this._onTriggerClick(id, el));
        });
    }

    _onTriggerClick = (id, triggerElement) => {
        this._showContent(id, triggerElement);
    };

    _showContent(id, triggerElement) {
        const contentToShow = this.contentById[id];
        if (!contentToShow) {
            throw new Error(`No content for id ${id}`);
        }

        if (this.activeContent) {
            this.activeContent.classList.remove(CLASS_ACTIVE);
            this.activeContent.setAttribute('aria-hidden', 'true');
        }

        if (this.activeTrigger) {
            this.activeTrigger.classList.remove(CLASS_ACTIVE);
        }

        dcFactory.init(contentToShow, true);
        contentToShow.classList.add(CLASS_ACTIVE);
        contentToShow.removeAttribute('aria-hidden');
        triggerElement.classList.add(CLASS_ACTIVE);
        this.activeContent = contentToShow;
        this.activeTrigger = triggerElement;
    }
}
